import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FiUpload, FiFolderPlus, FiImage, FiLogOut } from "react-icons/fi";
import { FaLink } from "react-icons/fa6";

const AdminDashboard = () => {
    const navigate = useNavigate();

    const dashboardLinks = [
        {
            title: "Item Upload",
            description: "Upload Image of Products",
            icon: <FiUpload className="text-4xl" />,
            color: "bg-gradient-to-r from-cyan-500 to-blue-600",
            hoverColor: "hover:from-cyan-600 hover:to-blue-700",
            path: "/image",
        },
        {
            title: "Category Upload",
            description: "Upload Image of Categories",
            icon: <FiFolderPlus className="text-4xl" />,
            color: "bg-gradient-to-r from-emerald-500 to-green-600",
            hoverColor: "hover:from-emerald-600 hover:to-green-700",
            path: "/catimage",
        },
        {
            title: "Poster Upload",
            description: "Upload Offer Poster",
            icon: <FiImage className="text-4xl" />,
            color: "bg-gradient-to-r from-violet-500 to-purple-600",
            hoverColor: "hover:from-violet-600 hover:to-purple-700",
            path: "/poster",
        },
        {
            title: "Home Edit",
            description: "Edit Home Category Display",
            icon: <FiFolderPlus className="text-4xl" />,
            color: "bg-gradient-to-r from-indigo-500 to-sky-600",
            hoverColor: "hover:from-indigo-600 hover:to-sky-700",
            path: "/homeedit",
        },
        {
            title: "Video Link",
            description: "Setup links for Videos",
            icon: <FaLink className="text-4xl" />,
            color: "bg-gradient-to-r from-indigo-500 to-sky-600",
            hoverColor: "hover:from-indigo-600 hover:to-sky-700",
            path: "/videolink",
            state: { cutitemId: "", categoryId: "" },
        },
        {
            title: "Exit",
            description: "Back to Login",
            icon: <FiLogOut className="text-4xl" />,
            color: "bg-gradient-to-r from-rose-500 to-pink-600",
            hoverColor: "hover:from-rose-600 hover:to-pink-700",
            path: "/",
        },
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.5,
                ease: "easeOut",
            },
        },
        hover: {
            scale: 1.05,
            boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
            transition: {
                duration: 0.3,
            },
        },
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-8">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-12"
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">
                        Admin Dashboard
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Welcome back! Manage your content with these quick actions
                    </p>
                </motion.div>

                <motion.div
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {dashboardLinks.map((link, index) => (
                        <motion.div
                            key={index}
                            className={`${link.color} ${link.hoverColor} rounded-2xl p-8 text-white cursor-pointer h-60 flex flex-col justify-between shadow-lg transition-all duration-300 group`}
                            variants={itemVariants}
                            whileHover="hover"
                            onClick={() => navigate(link.path, { state: link.state || {} })} // Pass state if it exists
                        >
                            <div className="flex flex-col">
                                <div className="w-14 h-14 rounded-xl bg-white bg-opacity-20 flex items-center justify-center mb-6 group-hover:bg-opacity-30 transition-all">
                                    {link.icon}
                                </div>
                                <h2 className="text-2xl font-bold mb-2">{link.title}</h2>
                                <p className="opacity-90 text-white/90">{link.description}</p>
                            </div>
                            <div className="flex justify-end items-center">
                                <span className="mr-2 text-sm font-medium">Go to</span>
                                <div className="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center group-hover:bg-opacity-30 transition-all">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
};

export default AdminDashboard;
